// src/utils/tutorLines.js
// Fixed mascot lines. Greetings, thanks and "ok" never call the AI.

export const LINES = {
  welcome: [
    "Hi {{name}}! I'm your octopus buddy. Ask me anything science!",
    "Eight arms, one big brain, all yours. What are we exploring today, {{name}}?",
  ],
  goalSaved: [
    "Love it! We're working toward: {{goal}}. Ask me anything science!",
    "Great goal! {{goal}}. I'm with you all the way. What shall we learn first?",
  ],
  goalChanged: [
    "New goal saved: {{goal}}. I'm with you, let's go!",
    "Got it, our new goal is {{goal}}. Where shall we start?",
  ],
  greeting: [
    "Hey {{name}}! Ready for some science?",
    "Hello! What's on your mind today?",
  ],
  thanks: [
    "Anytime! You did the hard part.",
    "Happy to help. Proud of you for sticking with it!",
  ],
  ack: [
    "Great! Want to try one more question?",
    "Nice. Ask me whenever you're ready.",
  ],
  cap: [
    "I'm sleepy, {{name}}. See you tomorrow!",
    "That's all my energy for today. My arms need a rest!",
  ],
  error: [
    "Oops, I got tangled in my own arms. Try again?",
    "My brain froze for a second. Please resend that.",
    "No signal in the deep sea. Check your connection?",
  ],
};

// A message only counts if the WHOLE message matches (after cleaning it up).
const TRIGGERS = {
  greeting: ["hi", "hii", "hiii", "hello", "hey", "heyy", "hlo", "yo", "hola"],
  thanks: ["thanks", "thank you", "thankyou", "thx", "ty", "thanks a lot"],
  ack: ["ok", "okay", "okk", "kk", "k", "cool", "nice", "got it", "alright"],
};

const normalize = (text) =>
  String(text || "")
    .toLowerCase()
    .replace(/[^a-z\s]/g, " ")
    .replace(/\s+/g, " ")
    .trim();

// Returns "greeting" | "thanks" | "ack" | null
export const matchCanned = (text) => {
  const n = normalize(text);
  if (!n) return null;
  for (const [key, words] of Object.entries(TRIGGERS)) {
    if (words.includes(n)) return key;
  }
  return null;
};

// Random line, never the same one twice in a row
const lastPicked = {};
export const pickLine = (key) => {
  const list = LINES[key];
  let i = Math.floor(Math.random() * list.length);
  if (list.length > 1 && i === lastPicked[key]) i = (i + 1) % list.length;
  lastPicked[key] = i;
  return list[i];
};

export const fillLine = (line, { name = "friend", goal = "" } = {}) =>
  line.replace(/{{name}}/g, name).replace(/{{goal}}/g, goal);